import { Link } from "react-router-dom";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import Icon from "../Icon";
import ImageCover from "../ImageCover";
import "./style.scss";

const PagePreview = ({ title, path, image, tagLine }) => {
  const t = useBjelinTranslations();

  return (
    <div
      style={{
        display: "block",
        position: "relative"
      }}
      className="page-preview"
    >
      <Link
        to={path}
        style={{
          display: "block",
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }}
      >
        <ImageCover
          imageUrl={image}
          contentStyle={{
            display: "block",
            padding: "1em",
            justifyContent: "flex-start"
          }}
        >
          <h4 style={{ fontSize: "1.4em" }}>{title}</h4>
          <p style={{ fontSize: "0.9em", marginBottom: 0 }}>{tagLine}</p>
          <p style={{ fontSize: "0.9em", fontWeight: "500" }}>
            {t("read.more")} <Icon name="chevron-right" className="ms-1" />
          </p>
        </ImageCover>
      </Link>
    </div>
  );
};

export default PagePreview;
